@if (!editMode && control.value) {
  <div
    (click)="editMode = !editMode"
    class="input-box input-box--border input-box--no-icon encrypted"
  >
    {{ control.value | encrypt: 'X' : 3 }}
  </div>
}
@if (!editMode && !control.value) {
  <div
    (click)="editMode = !editMode"
    class="input-box input-box--border input-box--no-icon encrypted ng-invalid"
  ></div>
}
@if (editMode) {
  <input
    appInput
    [border]="true"
    [noIcon]="true"
    id="free-text-input"
    [readonly]="readOnly"
    [attr.aria-label]="name | splitCamelCase"
    [formControl]="control"
    (change)="change($event)"
    name="value"
  />
}
